import React from 'react';
import FormDrawer from "components/__new/common/form-drawer";
import { ReactComponent as IconInfo } from 'assets/images/icons/project-icons/information-new.svg';
import { ButtonLoader } from "components/__new/common/form";
import Maybe from "components/__new/common/Maybe";

export const OptInYield = (props) => {
    const { isOpen, setIsOpen, employer, handleOptInOutYield, optInOutYieldLoading, hasAgreed, setHasAgreed } = props;
    
    return (
        <FormDrawer display="center" size="lg" isOpen={isOpen} setIsOpen={setIsOpen}>
            <div className="p-6">
                <FormDrawer.Title
                    title="Opt-In For Yield"
                    showCloseButton={true}
                    close={setIsOpen}
                />
                <div className="mt-4 bg-[#FEF5E7] p-3 rounded-2xl flex items-center">
                    <IconInfo className="text-[#F49D1B] mr-3"/>
                    <span>Please read the information below</span>
                </div>

                <div className="mt-4">
                    <div className="font-medium text-lg">
                        Terms and Conditions for Yield
                    </div>
                    <div>
                        <p className='text-[#1A202C] mt-4 text-lg mb-2'>Yield Terms</p>
                        <ol className='pl-2'>
                            <li className='text-[#4A5564] mb-2 flex text-base'>
                                <span>1.&nbsp;&nbsp;</span>
                                <span>Earnipay offers Yield on the sitting balance of only expense accounts held by our user.</span>
                            </li>
                            <li className='text-[#4A5564] mb-2 flex text-base'>
                                <span>2.&nbsp;&nbsp;</span>
                                <span>User must opt in for the Yield feature before they begin accruing yield.</span>    
                            </li>
                            <li className='text-[#4A5564] mb-2 flex text-base'>
                                <span>3.&nbsp;&nbsp;</span>
                                <span>A minimum balance of ₦10,000.00 is also required for the daily interest to apply.</span>    
                            </li>
                            <li className='text-[#4A5564] mb-2 flex text-base'>
                                <span>4.&nbsp;&nbsp;</span>
                                <span>Fees, if any, associated with the account will be disclosed separately and are subject to change with prior notice to the User.</span>
                            </li>
                        </ol>
                    </div>
                    <div>
                        <p className='text-[#1A202C] mt-4 text-lg mb-2'>Yield Earnings</p>
                        <ol className='pl-2'>
                            <li className='text-[#4A5564] mb-2 flex text-base'>
                                <span>1.&nbsp;&nbsp;</span>
                                <span>Earnipay reserves the right to adjust the terms here with prior notice to the user.</span>
                            </li>
                            <li className='text-[#4A5564] mb-2 flex text-base'>
                                <span>2.&nbsp;&nbsp;</span>
                                <span>Earnipay reserves the right to adjust interest rates or yield earnings at its discretion, with notice provided to the user in accordance with regulatory requirements.</span>    
                            </li>
                            <li className='text-[#4A5564] mb-2 flex text-base'>
                                <span>3.&nbsp;&nbsp;</span>
                                <span>Interest or yield earnings will be calculated based on the closing balance of funds in the account daily and credited monthly to their main account.</span>
                            </li>
                        </ol>
                    </div>
                </div>
                
                <div className="mt-8 bg-[#EAFBF6] rounded-lg p-3">
                    <div className="flex items-center">
                        <input
                            onChange={() => {
                                setHasAgreed(!hasAgreed);
                            }}
                            checked={hasAgreed}
                            type="checkbox" 
                            className="w-4 h-4 mr-3 form-checkbox float-left"
                        />
                        <span className='text-[#101828] text-base'>I agree to the terms and conditions</span>
                    </div>
                </div>

                <div className="p-1 mt-8 flex items-center space-x-3">
                    <button type="button" className="btn btn-lg w-full rounded-lg whitespace-nowrap border border-ep-primary-600 text-ep-primary-600 bg-white"
                    onClick={() => setIsOpen(false)}
                    >
                        Not Now
                    </button>
                    <ButtonLoader onClick={handleOptInOutYield} loading={optInOutYieldLoading} disabled={!hasAgreed} type="button" className="btn btn-lg w-full rounded-lg whitespace-nowrap border border-ep-primary-600 text-white bg-ep-primary-600">
                        Opt-In
                    </ButtonLoader>
                </div>
            </div>
        </FormDrawer>
    )
}
